import type BackOfficeConnector from "../data/backOfficeConnector";
import type EventBus from "../services/eventBus";
import { serializeFilters } from "utils/filters";
import RepositoryBase from "./repositoryBase";
import type { IPagination } from "../data/types";
import type SearchVehicleRegisterVehiclesRequest from "entities/searchVehicleRegisterVehiclesRequest";
import VehicleRegisterVehicle from "entities/vehicleRegisterVehicleResponse";
import VehicleRegisterVehicleDetailResponse from "entities/vehicleRegisterVehicleDetailResponse";
import VehicleRegisterVehicleChangeResponse from "entities/vehicleRegisterVehicleChangeResponse";
import type VehicleRegisterVehiclesTotalCountRequest from "entities/vehicleRegisterVehiclesTotalCountRequest";
import VehicleRegisterVehiclesTotalCountResponse from "entities/vehicleRegisterVehiclesTotalCountResponse";

export default class VehicleRegisterRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAll(filters: SearchVehicleRegisterVehiclesRequest, pagination: IPagination, abortSignal?: AbortSignal) {
    return this.callApi(
      api =>
        api
          .all("call_center")
          .all("vehicle_register_vehicle_search")
          .postPagedEntities<VehicleRegisterVehicle>(
            { ...serializeFilters(filters, false), ...pagination },
            VehicleRegisterVehicle,
            abortSignal
          ),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }

  getOne(vehicleId: string) {
    return this.callApi(
      api => api.all("call_center").one("vehicle_register_vehicles", vehicleId).getEntity(VehicleRegisterVehicleDetailResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }

  getAllChanges(vehicleRegister: VehicleRegisterVehicle) {
    return this.callApi(
      api =>
        api
          .all("call_center")
          .one("vehicle_register_vehicles", vehicleRegister.vehicleId)
          .all("changes")
          .getEntities(VehicleRegisterVehicleChangeResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }

  getVehicleSynchronizations(vehicleId: string) {
    return this.callApi(
      api => api.all("call_center").one("vehicle_register_vehicles", vehicleId).all("synchronizations").post({}),

      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }
  totalCount(entity: VehicleRegisterVehiclesTotalCountRequest) {
    return this.callApi(
      api =>
        api
          .all("call_center")
          .all("vehicle_register_vehicle_search")
          .all("total_count")
          .postEntity<VehicleRegisterVehiclesTotalCountResponse>(
            { ...serializeFilters(entity, false) },
            VehicleRegisterVehiclesTotalCountResponse
          ),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }
}
